export default {
  zh: {
    common: {
      search: '搜索',
      reset: '重置',
      more: '更多',
      hide: '收起',
      import: '导入',
      export: '导出',
      select: '选择',
      operationSuccess: '操作成功',
      yuan: '元',
      tip: '提示',
      confirm: '确定',
      cancel: '取消'
    },
    listManualOweFee: {
      search: {
        title: '查询条件',
        floorName: '楼栋名称',
        unit: '单元',
        roomNum: '房间号',
        roomType: '房屋类型',
        ownerName: '业主姓名',
        ownerTel: '业主电话',
        mofcName: '批次号',
        statePlaceholder: '短信状态',
        payObjType: '付费对象',
        feeConfig: '收费项',
        roomNumFormat: '房间号格式(如1-1-101)',
        carportNum: '车位号'
      },
      table: {
        title: '手工欠费信息',
        index: '序号',
        mofcName: '批次号',
        roomName: '房间号',
        ownerName: '业主姓名',
        ownerTel: '联系电话',
        startTime: '计费开始日期',
        endTime: '计费结束日期',
        amountdOwed: '欠费金额',
        createTime: '创建时间',
        state: '短信状态',
        remark: '备注'
      },
      summary: {
        subtotal: '欠费小计:',
        total: '欠费合计'
      },
      state: {
        all: '全部',
        W: '待催缴',
        C: '催缴完成',
        F: '催缴失败',
        D: '催缴中'
      },
      button: {
        smsReminder: '短信催缴',
        delete: '删除'
      },
      delete: {
        confirmMessage: '是否确认删除？(催缴完成无法删除)',
        success: '成功删除 {count} 条记录',
        failed: '删除失败',
        error: '删除手工欠费记录异常'
      },
      smsReminder: {
        confirmMessage: '确定要发送催缴短信吗？(同一手机号发送成功后，三天内不能重复发送)',
        success: '正在发送 {count} 条催缴短信，请稍后查看发送结果',
        failed: '短信发送失败',
        error: '发送催缴短信异常',
        errorFailed: '发送催缴短信失败'
      },
      filter: {
        current: '当前筛选：',
        clear: '清除筛选',
        yearMonth: '年月：',
        batchNo: '批次号：',
        roomNum: '房间号：',
        ownerName: '业主姓名：',
        ownerTel: '业主电话：',
        smsStatus: '短信状态：'
      },
      importSuccess: '导入成功，已加载批次号：{mofcName} 的数据',
      exportError: '导出失败',
      // 手工欠费导入组件
      importManualOweFee: {
        title: '手工欠费导入',
        selectFile: '选择文件',
        clickUpload: '点击上传',
        requiredFile: '必填，请选择数据文件',
        downloadTemplate: '下载模板',
        downloadFirst: '请先下载',
        propertyTemplate: '导入模板',
        prepareData: '准备数据后，上传导入',
        fileRequired: '文件不能为空',
        invalidFormat: '不是有效的Excel格式',
        fileSizeExceeded: 'Excel文件大小不能超过2M',
        importSuccess: '导入成功',
        importFailed: '导入失败',
        importError: '导入出错'
      }
    },
    // 批次树组件的国际化
    batchTree: {
      loadError: '加载批次树失败'
    }
  },
  en: {
    common: {
      search: 'Search',
      reset: 'Reset',
      more: 'More',
      hide: 'Hide',
      import: 'Import',
      export: 'Export',
      select: 'Select',
      operationSuccess: 'Operation Success',
      yuan: 'Yuan',
      tip: 'Tip',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    listManualOweFee: {
      search: {
        title: 'Search Conditions',
        floorName: 'Building Name',
        unit: 'Unit',
        roomNum: 'Room Number',
        roomType: 'Room Type',
        ownerName: 'Owner Name',
        ownerTel: 'Owner Phone',
        mofcName: 'Batch No.',
        statePlaceholder: 'SMS Status',
        payObjType: 'Payer Type',
        feeConfig: 'Fee Config',
        roomNumFormat: 'Room format (e.g. 1-1-101)',
        carportNum: 'Carport Number'
      },
      table: {
        title: 'Manual Owe Fee Information',
        index: 'No.',
        mofcName: 'Batch No.',
        roomName: 'Room Name',
        ownerName: 'Owner Name',
        ownerTel: 'Phone Number',
        startTime: 'Start Date',
        endTime: 'End Date',
        amountdOwed: 'Amount Owed',
        createTime: 'Create Time',
        state: 'SMS Status',
        remark: 'Remark'
      },
      summary: {
        subtotal: 'Subtotal:',
        total: 'Total'
      },
      state: {
        all: 'All',
        W: 'Pending',
        C: 'Completed',
        F: 'Failed',
        D: 'Processing'
      },
      button: {
        smsReminder: 'Send SMS Reminder',
        delete: 'Delete'
      },
      delete: {
        confirmMessage: 'Confirm deletion? (Completed records cannot be deleted)',
        success: 'Successfully deleted {count} records',
        failed: 'Deletion failed',
        error: 'Error deleting manual owe fee records'
      },
      smsReminder: {
        confirmMessage: 'Are you sure you want to send collection SMS? (Same phone number cannot be resent within 3 days after successful sending)',
        success: 'Sending {count} collection SMS, please check results later',
        failed: 'SMS sending failed',
        error: 'Error sending collection SMS',
        errorFailed: 'Failed to send collection SMS'
      },
      filter: {
        current: 'Current Filter: ',
        clear: 'Clear Filter',
        yearMonth: 'Year-Month: ',
        batchNo: 'Batch No.: ',
        roomNum: 'Room Number: ',
        ownerName: 'Owner Name: ',
        ownerTel: 'Owner Phone: ',
        smsStatus: 'SMS Status: '
      },
      importSuccess: 'Import successful, loaded data for batch: {mofcName}',
      exportError: 'Export failed',
      // Manual owe fee import component
      importManualOweFee: {
        title: 'Manual Owe Fee Import',
        selectFile: 'Select File',
        clickUpload: 'Click to upload',
        requiredFile: 'Required, please select data file',
        downloadTemplate: 'Download Template',
        downloadFirst: 'Please download first',
        propertyTemplate: 'Import Template',
        prepareData: 'to prepare data, then upload for import',
        fileRequired: 'File cannot be empty',
        invalidFormat: 'Invalid Excel format',
        fileSizeExceeded: 'Excel file size cannot exceed 2MB',
        importSuccess: 'Import successful',
        importFailed: 'Import failed',
        importError: 'Import error occurred'
      }
    },
    // 批次树组件的国际化
    batchTree: {
      loadError: 'Failed to load batch tree'
    }
  }
}
